import { ConnectionTrigger } from "../../typings/types"

export const confirmUrl = ({
  trigger,
  inviteDomain,
}: {
  trigger: ConnectionTrigger
  inviteDomain?: string
}) => {
  let confirmUrl = `/confirm-payment?plan=${
    trigger ? ConnectionTrigger.AUTOMATIC : ConnectionTrigger.MANUAL
  }`
  if (inviteDomain) confirmUrl += `&invite=${inviteDomain}`
  return confirmUrl
}
